import {
  CopyOutlined,
  FileExcelOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Row,
  Space,
  // Form,
  Table,
  Tabs,
  Tooltip,
  message,
  Pagination,
} from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import { useEffect, useMemo, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import {
  deleteCurrentStockList,
  fetchCurrentStockDataList,
  fetchCurrentStockItemList,
  fetchCurrentStockItemWiseSummary,
} from '../../slices/warehouse';
import { shiftBundleExcessStock } from '../../slices/bundleinword';
import { debounce } from 'lodash';
import { createActivityLog } from '../../slices/activity-log';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';

function WareHouseCurrentStock() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState(
    localStorage.getItem('die_text_search_Warehouse_Party') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('die_text_search_Warehouse_Party') || '',
  );
  const [inputValueCurrentStock, setInputValueCurrentStock] = useState(
    localStorage.getItem('die_text_search_Warehouse_CurrentStock') || '',
  );
  const [searchCurrentStock, setSearchCurrentStock] = useState(
    localStorage.getItem('die_text_search_Warehouse_CurrentStock') || '',
  );
  const [searchItemStockSummary, setSearchStockSummary] = useState(
    localStorage.getItem('die_text_search_Warehouse_StockSummary') || '',
  );
  const [inputValueStockSummary, setInputValueStockSummary] = useState(
    localStorage.getItem('die_text_search_Warehouse_StockSummary') || '',
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Track
  const [selectedSummaryRowKeys, setSelectedSummaryRowKeys] = useState([]);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  // const [form] = Form.useForm();
  const {
    dataCurrentStock = [],
    dataCurrentStockCounts = {},
    totalRecordsCurrentStock,
    statusThree,
  } = useSelector(state => state.warehouse);
  const {
    dataSummary = [],
    dataSummarycount = {},
    totalRecordsSummaryWise,
    statusFour,
  } = useSelector(state => state.warehouse);
  const {
    dataPartyWise = [],
    dataPartyWiseCounts = {},
    totalRecords,
    totalRecordsPartyWise,
    status,
  } = useSelector(state => state.warehouse);

  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesizePartyWise, setPagesize] = useState(100);
  const [pageCurrentStock, setPageCurrentStock] = useState(1);
  const [pagesizeCurrentStock, setPagesizeCurrentStock] = useState(100);
  const [pageItemWiseSummary, setPageItemWiseSummary] = useState(1);
  const [pagesizeItemWiseSummary, setPagesizeItemWiseSummary] = useState(100);
  const csvLinkRef = useRef();
  const [csvData, setCsvData] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);
  const dataSource = dataPartyWise.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesizePartyWise + index + 1,
  }));

  const dataSourceThree = dataCurrentStock.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (pageCurrentStock - 1) * pagesizeCurrentStock + index + 1,
  }));

  const dataSourceFour = dataSummary.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (pageItemWiseSummary - 1) * pagesizeItemWiseSummary + index + 1,
  }));
  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    if (activeTab === '1') {
      dispatch(
        fetchCurrentStockDataList({
          page,
          pagesize: pagesizePartyWise,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      );
    }
  }, [activeTab, page, pagesizePartyWise, search, orderBy, dispatch]);

  useEffect(() => {
    if (activeTab === '2') {
      dispatch(
        fetchCurrentStockItemList({
          page: pageCurrentStock,
          pagesize: pagesizeCurrentStock,
          ...(searchCurrentStock && { search: searchCurrentStock }),
          ...(orderBy && { ordering: orderBy }),
        }),
      );
    }
  }, [
    activeTab,
    pageCurrentStock,
    pagesizeCurrentStock,
    searchCurrentStock,
    orderBy,
    dispatch,
  ]);

  useEffect(() => {
    if (activeTab === '3') {
      dispatch(
        fetchCurrentStockItemWiseSummary({
          page: pageItemWiseSummary,
          pagesize: pagesizeItemWiseSummary,
          ...(searchItemStockSummary && { search: searchItemStockSummary }),
          ...(orderBy && { ordering: orderBy }),
        }),
      );
    }
  }, [
    activeTab,
    pageItemWiseSummary,
    pagesizeItemWiseSummary,
    searchItemStockSummary,
    orderBy,
    dispatch,
  ]);

  useEffect(() => {
    if (activeTab === '1') {
      const storedSearch =
        localStorage.getItem('die_text_search_Warehouse_Party') || '';
      setSearch(storedSearch);
      setInputValue(storedSearch);
    } else if (activeTab === '2') {
      const storedSearch =
        localStorage.getItem('die_text_search_Warehouse_CurrentStock') || '';
      setSearchCurrentStock(storedSearch);
      setInputValueCurrentStock(storedSearch);
    } else if (activeTab === '3') {
      const storedSearch =
        localStorage.getItem('die_text_search_Warehouse_StockSummary') || '';
      setSearchStockSummary(storedSearch);
      setInputValueStockSummary(storedSearch);
    }
  }, [activeTab]);

  const loadedTabsRef = useRef({
    1: false,
    2: false,
    3: false,
  });

  useEffect(() => {
    if (activeTab === undefined) {
      dispatch(setActiveTab('1'));
    }
  }, [activeTab, dispatch]);

  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'bundle_no',
    'profile',
    'length_mm',
    'profile_description',
    'pieces',
    'weight_kg',
    'avg_weight_kg',
    'packing_date',
    'customer_name',
    'action',
  ]);
  const [checkedListTwo, setCheckedListTwo] = useState([
    'SrNo',
    'customer_name',
    'packed_weight',
  ]);
  const [checkedListThree, setCheckedListThree] = useState([
    'SrNo',
    'workorder_no',
    'profile',
    'length',
    'customer_name',
    'alloy',
    'total_weight',
    'total_pieces',
    'total_bundles',
  ]);
 

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const handleColumnVisibilityChangeParty = checkedValues => {
    setCheckedListTwo(checkedValues);
  };
  const handleColumnVisibilityChangeItemWise = checkedValues => {
    setCheckedListThree(checkedValues);
  };

  let visibleCounts = {};
  if (activeTab === '1') {
    visibleCounts = dataPartyWiseCounts;
  } else if (activeTab === '2') {
    visibleCounts = dataCurrentStockCounts;
  } else if (activeTab === '3') {
    visibleCounts = dataSummarycount;
  }

  const handleTabChange = key => {
    setActiveTab(key);
    setSearch('');
  };


  const filteredColumnsStock = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '8%',
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
      render: (text, record) => (
        <span
          style={{ cursor: 'pointer' }}
          className="linktxt"
          onClick={() =>
            navigate(`/warehouse-current-stock-details/${record.id}`)
          }
        >
          {text}
        </span>
      ),
    },
    {
      title: 'Packed Weight',
      dataIndex: 'packed_weight',
      key: 'packed_weight',
      render: text => (
        <span>
          {Number(text).toLocaleString(undefined, {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          })}{' '}
          kg
        </span>
      ),
    },
  ];

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '8%',
    },
    {
      title: 'Bundle No',
      dataIndex: 'bundle_no',
      key: 'bundle_no',
      sorter: true,
    },
    {
      title: 'Profile',
      dataIndex: 'profile',
      key: 'profile',
      sorter: true,
    },
    {
      title: 'Length (mm)',
      dataIndex: 'length_mm',
      key: 'length_mm',
      sorter: true,
    },
    {
      title: 'Profile Description',
      dataIndex: 'profile_description',
      key: 'profile_description',
      sorter: true,
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
      sorter: true,
    },
    {
      title: 'Weight',
      dataIndex: 'weight_kg',
      key: 'weight_kg',
      sorter: true,
    },
    {
      title: 'Avg Wt(kg)',
      dataIndex: 'avg_weight_kg',
      key: 'avg_weight_kg',
      render: avg_weight_kg => <span>{avg_weight_kg?.toFixed(3)}</span>,
    },
    {
      title: 'Packing Date',
      dataIndex: 'packing_date',
      key: 'packing_date',
      sorter: true,
      render: packing_date => (
        <span>
          {dayjs(packing_date).format('DD-MM-YYYY h:mm A').toLowerCase()}
        </span>
      ),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
    },
  ];
  const filteredColumnsItemWiseStock = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '8%',
    },
    {
      title: 'Work Order No',
      dataIndex: 'workorder_no',
      key: 'workorder_no',
      sorter: true,
    },
    {
      title: 'Profile',
      dataIndex: 'profile',
      key: 'profile',
      sorter: true,
    },
    {
      title: 'Length (mm)',
      dataIndex: 'length',
      key: 'length',
      sorter: true,
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
    },
    {
      title: 'Alloy/ Color Code',
      dataIndex: 'alloy',
      key: 'alloy',
      sorter: true,
    },
    {
      title: 'Total Weight',
      dataIndex: 'total_weight',
      key: 'total_weight',
      sorter: true,
    },
    {
      title: 'Total Pieces',
      dataIndex: 'total_pieces',
      key: 'total_pieces',
      sorter: true,
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundles',
      key: 'total_bundles',
      sorter: true,
    },
  ];

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );
  const filteredColumnsParty = filteredColumnsStock.filter(column =>
    checkedListTwo.includes(column.key),
  );
  const filteredColumnsItemWise = filteredColumnsItemWiseStock.filter(column =>
    checkedListThree.includes(column.key),
  );
  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => setSelectedRowKeys(selectedRowKeys),
  };

  const handleCopy = async () => {
    const count = totalRecordsPartyWise;
    if (count > 0) {
      try {
        const response = await dispatch(
          fetchCurrentStockDataList({
            page: 1,
            pagesize: count,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();

        const customerDetails = response?.results?.data?.customer_details;
        if (customerDetails && customerDetails.length > 0) {
          const columnLabels = {
            SrNo: 'Sr. No.',
            customer_name: 'Customer Name',
            packed_weight: 'Packed Weight (kg)',
          };
          const headers = checkedListTwo.map(col => columnLabels[col] || col);
          let tableText = headers.join('\t') + '\n';
          customerDetails.forEach((item, index) => {
            const row = checkedListTwo.map(col => {
              if (col === 'SrNo') return index + 1;

              if (col === 'packed_weight') {
                return `\u200B${Number(item[col]).toLocaleString('en-IN', {
                  minimumFractionDigits: 1,
                  maximumFractionDigits: 1,
                })}`;
              }

              return item[col] ?? '';
            });
            tableText += row.join('\t') + '\n';
          });
          await navigator.clipboard.writeText(tableText);
        } else {
          console.warn('No customer details found.');
        }
      } catch (error) {
        console.error('Failed to fetch or copy:', error);
      }
    }
  };

  const handleCopycurrentstock = async () => {
    try {
      const count = totalRecordsCurrentStock || 0;

      if (count > 0) {
        const response = await dispatch(
          fetchCurrentStockItemList({
            page: 1,
            pagesize: count,
            ...(searchCurrentStock && { search: searchCurrentStock }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();
        const bundles =
          response?.results?.data?.bundles ||
          response?.data?.bundles ||
          response?.bundles ||
          response?.results ||
          [];
        if (bundles.length > 0) {
          const columnLabels = {
            SrNo: 'Sr. No.',
            bundle_no: 'Bundle No.',
            profile: 'Profile',
            length_mm: 'Length (mm)',
            profile_description: 'Profile Description',
            pieces: 'Pieces',
            weight_kg: 'Weight (kg)',
            avg_weight_kg: 'Avg Wt(kg)',
            packing_date: 'Packing Date',
            customer_name: 'Customer Name',
          };

          const columnsToInclude = checkedList.filter(col => col !== 'action');
          let tableText = '';
          tableText +=
            columnsToInclude.map(col => columnLabels[col] || col).join('\t') +
            '\n';
          bundles.forEach((bundle, index) => {
            const rowValues = columnsToInclude.map(col => {
              if (col === 'SrNo') return index + 1;

              if (col === 'weight_kg' || col === 'packed_weight') {
                return bundle[col]
                  ? Number(bundle[col]).toLocaleString('en-IN', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  })
                  : '';
              }

              if (col === 'avg_weight_kg') {
                return bundle[col] ? Number(bundle[col]).toFixed(3) : '';
              }

              if (col === 'packing_date') {
                return bundle[col]
                  ? dayjs(bundle[col]).format('DD-MM-YYYY h:mm A').toLowerCase()
                  : '';
              }

              if (col === 'profile') {
                return bundle[col] !== undefined ? `\u200B${bundle[col]}` : '';
              }

              return bundle[col] !== undefined ? String(bundle[col]) : '';
            });

            tableText += rowValues.join('\t') + '\n';
          });
          await navigator.clipboard.writeText(tableText);
          message.success(
            'Table data copied to clipboard! You can now paste it into Excel.',
          );
        } else {
          console.warn('No bundle data found.');
          message.warning('No data to copy.');
        }
      } else {
        message.info('No records available to copy.');
      }
    } catch (error) {
      console.error('Failed to fetch or copy bundle data:', error);
      message.error(
        'Failed to copy data: ' + (error.message || 'Unknown error'),
      );
    }
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Warehouse Current Stock',
        ip_address: ipAddress,
        discription: 'Warehouse current stock excel download successfully!',
      }),
    );
  };
  const handleCopyItemWiseSummary = async () => {
    const countItemWiseSummary = totalRecordsSummaryWise;

    if (countItemWiseSummary > 0) {
      try {
        const response = await dispatch(
          fetchCurrentStockItemWiseSummary({
            page: 1,
            pagesize: countItemWiseSummary,
            ...(searchItemStockSummary && { search: searchItemStockSummary }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();

        const summaryData = response?.results?.data?.summary;

        if (summaryData && summaryData.length > 0) {
          const columnLabels = {
            SrNo: 'Sr. No.',
            workorder_no: 'Work Order',
            profile: 'Profile',
            length: 'Length',
            customer_name: 'Customer Name',
            alloy: 'Alloy/Colorcode',
            total_weight: 'Total Weight (kg)',
            total_pieces: 'Total Pieces',
            total_bundles: 'Total Bundles',
          };
          const headers = checkedListThree.map(col => columnLabels[col] || col);
          let tableText = headers.join('\t') + '\n';
          summaryData.forEach((item, index) => {
            const row = checkedListThree.map(col => {
              if (col === 'SrNo') return index + 1;
              const val = item[col];

              if (col === 'total_weight') {
                return val
                  ? Number(val).toLocaleString('en-IN', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  })
                  : '';
              }

              if (col === 'profile') {
                return val !== undefined ? `\u200B${val}` : '';
              }

              return val !== undefined ? String(val) : '';
            });

            tableText += row.join('\t') + '\n';
          });

          await navigator.clipboard.writeText(tableText);
          message.success(
            'Table data copied to clipboard! You can now paste it into Excel.',
          );
        } else {
          console.warn('No summary data found.');
        }
      } catch (error) {
        console.error('Failed to fetch or copy summary data:', error);
      }
    }
  };

  const allCsvColumns = [
    { header: 'Sr.No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Customer name', dataKey: 'customer_name', field: 'customer_name' },
    { header: 'Packed Weight', dataKey: 'packed_weight', field: 'packed_weight' },
  ];

  const handleExcel = async () => {
    const count = totalRecordsPartyWise;

    if (count > 0) {
      const response = await dispatch(
        fetchCurrentStockDataList({
          page: 1,
          pagesize: count,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ).unwrap();

      const customerDetails = response?.results?.data?.customer_details || [];
      const csvListData = customerDetails.map((item, index) => {
        const row = {
          SrNo: index + 1,
        };

        allCsvColumns
          .filter(col => checkedListTwo.includes(col.field))
          .forEach(col => {
            if (col.field === 'SrNo') return;

            switch (col.field) {
              case 'customer_name':
                row.customer_name = item?.customer_name || 'N/A';
                break;
              case 'packed_weight':
                row.packed_weight =
                  Number(item?.packed_weight)?.toFixed(3) || 'N/A';
                break;
              default:
                row[col.dataKey] = 'N/A';
            }
          });
        return row;
      });

      setCsvData(csvListData);
      setTimeout(() => {
        csvLinkRef.current?.link.click();
      }, 500);
    }
  };
  const csvHeaders = allCsvColumns
    .filter(col => checkedListTwo.includes(col.field))
    .map(col => ({
      label: col.header,
      key: col.dataKey,
    }));

  const handleCopyBasedOnTab = () => {
    if (activeTab === '1') {
      handleCopy();
    } else if (activeTab === '2') {
      handleCopycurrentstock();
    } else if (activeTab === '3') {
      handleCopyItemWiseSummary();
    }
  };

  const handleColumnsBasedOnTab = () => {
    if (activeTab === '1') {
      PartyWiseColumns();
    } else if (activeTab === '2') {
      CurrentStockColumns();
    } else if (activeTab === '3') {
      ItemWiseStockSummaryColumns();
    }
  };
  const onSearchChange = e => {
    setSearch(e.target.value);
  };

  const handlePageChangePartyWise = (page, pageSize) => {
    setPage(page);
    setPagesize(pageSize);
  };

  const handlePageChangeCurrentStock = (page, pageSize) => {
    setPageCurrentStock(page);
    setPagesizeCurrentStock(pageSize);
  };

  const handlePageChangeItemWiseSummary = (page, pageSize) => {
    setPageItemWiseSummary(page);
    setPagesizeItemWiseSummary(pageSize);
  };

  const handlePageChangeParty = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const handleTableChangePartyWise = async (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValuePartyWise(
        sorter.columnKey,
        sorter.order,
      );
      setOrderBy(orderBy);
    }
    if (pagination?.pageSize) setPagesize(pagination.pageSize);
    if (pagination?.current) setPage(pagination.current);
  };

  const handleTableChangeCurrentStock = async (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValueCurrentStock(
        sorter.columnKey,
        sorter.order,
      );
      setOrderBy(orderBy);
    }
    if (pagination?.pageSize) setPagesizeCurrentStock(pagination.pageSize);
    if (pagination?.current) setPageCurrentStock(pagination.current);
  };

  const handleTableChangeItemWiseSummary = async (
    pagination,
    filters,
    sorter,
  ) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValueItemWiseSummary(
        sorter.columnKey,
        sorter.order,
      );
      setOrderBy(orderBy);
    }
    if (pagination?.pageSize) setPagesizeItemWiseSummary(pagination.pageSize);
    if (pagination?.current) setPageItemWiseSummary(pagination.current);
  };

  const handleSearch = e => {
    const value = e.target.value;
    debouncedAPICall(value);
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('die_text_search_Warehouse_Party', value);
  };

  const debouncedAPICall = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3) {
          dispatch(fetchCurrentStockDataList({ search: query }));
          localStorage.setItem('die_text_search_Warehouse_Party', query);
        }
      }, 100),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedAPICall.cancel();
    };
  }, [debouncedAPICall]);

  const handleSearchCurrentStock = e => {
    const value = e.target.value;
    debouncedAPICallCurrentStock(value); // ✅ FIXED HERE
    setInputValueCurrentStock(value);
    setSearchCurrentStock(value);
    localStorage.setItem('die_text_search_Warehouse_CurrentStock', value);
  };

  const debouncedAPICallCurrentStock = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3) {
          dispatch(fetchCurrentStockItemList({ page: 1, pagesize: 1000, search: query }));
          localStorage.setItem('die_text_search_Warehouse_CurrentStock', query);
        }
      }, 100),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedAPICallCurrentStock.cancel();
    };
  }, [debouncedAPICallCurrentStock]);

  const handleSearchStockSummary = e => {
    const value = e.target.value;
    debouncedAPICallStockSummary(value); // ✅ FIXED HERE
    setInputValueStockSummary(value);
    localStorage.setItem('die_text_search_Warehouse_StockSummary', value);
  };

  const debouncedAPICallStockSummary = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3) {
           setSearchStockSummary(query);
           setPageItemWiseSummary(1);
          //dispatch(fetchCurrentStockItemWiseSummary({ search: query }));
          localStorage.setItem('die_text_search_Warehouse_StockSummary', query);
        }
      }, 100),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedAPICallStockSummary.cancel();
    };
  }, [debouncedAPICallStockSummary]);

  const GetSortingEnumValuePartyWise = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'packed_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'packed_weight';
    }
    if (sortField === 'packed_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-packed_weight';
    }
    return sortingEnumKey;
  };

  const GetSortingEnumValueCurrentStock = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'bundle_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'bundle_no';
    }
    if (sortField === 'bundle_no' && sortOrder === 'descend') {
      sortingEnumKey = '-bundle_no';
    }
    if (sortField === 'profile' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile';
    }
    if (sortField === 'profile' && sortOrder === 'descend') {
      sortingEnumKey = '-profile';
    }
    if (sortField === 'length_mm' && sortOrder === 'ascend') {
      sortingEnumKey = 'length_mm';
    }
    if (sortField === 'length_mm' && sortOrder === 'descend') {
      sortingEnumKey = '-length_mm';
    }
    if (sortField === 'profile_description' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile_description';
    }
    if (sortField === 'profile_description' && sortOrder === 'descend') {
      sortingEnumKey = '-profile_description';
    }
    if (sortField === 'pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'pieces';
    }
    if (sortField === 'pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-pieces';
    }
    if (sortField === 'weight_kg' && sortOrder === 'ascend') {
      sortingEnumKey = 'weight_kg';
    }
    if (sortField === 'weight_kg' && sortOrder === 'descend') {
      sortingEnumKey = '-weight_kg';
    }
    if (sortField === 'packing_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'packing_date';
    }
    if (sortField === 'packing_date' && sortOrder === 'descend') {
      sortingEnumKey = '-packing_date';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };

  const GetSortingEnumValueItemWiseSummary = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'workorder_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'workorder_no';
    }
    if (sortField === 'workorder_no' && sortOrder === 'descend') {
      sortingEnumKey = '-workorder_no';
    }
    if (sortField === 'profile' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile';
    }
    if (sortField === 'profile' && sortOrder === 'descend') {
      sortingEnumKey = '-profile';
    }
    if (sortField === 'length' && sortOrder === 'ascend') {
      sortingEnumKey = 'length';
    }
    if (sortField === 'length' && sortOrder === 'descend') {
      sortingEnumKey = '-length';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'alloy' && sortOrder === 'ascend') {
      sortingEnumKey = 'alloy';
    }
    if (sortField === 'alloy' && sortOrder === 'descend') {
      sortingEnumKey = '-alloy';
    }
    if (sortField === 'total_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_weight';
    }
    if (sortField === 'total_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-total_weight';
    }
    if (sortField === 'total_pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_pieces';
    }
    if (sortField === 'total_pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-total_pieces';
    }
    if (sortField === 'total_bundles' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_bundles';
    }
    if (sortField === 'total_bundles' && sortOrder === 'descend') {
      sortingEnumKey = '-total_bundles';
    }
    return sortingEnumKey;
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable
    loadedTabsRef.current['1'] = false;
    localStorage.removeItem('die_text_search_Warehouse_Party');
    dispatch(fetchCurrentStockDataList({ page: 1, pagesizePartyWise })); // ✅ Party list
  };

  const resetFilterCurrentStock = () => {
    setSearchCurrentStock('');
    setInputValueCurrentStock('');
    setOrderBy(null); // if applicable
    loadedTabsRef.current['2'] = false;
    localStorage.removeItem('die_text_search_Warehouse_CurrentStock');
    setPagesizeCurrentStock(100);
    //dispatch(fetchCurrentStockItemList({ page: 1, pagesizeCurrentStock })); // ✅ Current Stock list
  };

  const resetFilterStockSummary = () => {
    setSearchStockSummary('');
    setInputValueStockSummary('');
    setOrderBy(null); // if applicable
    loadedTabsRef.current['3'] = false;
    localStorage.removeItem('die_text_search_Warehouse_StockSummary');
    //dispatch(fetchCurrentStockItemWiseSummary({ page: 1, pagesizeItemWiseSummary }));
  };

  const PartyWiseColumns = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedListTwo}
          onChange={handleColumnVisibilityChangeParty}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packed_weight">Packed Weight </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const CurrentStockColumns = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                {' '}
                Sr. No.{' '}
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="bundle_no">Bundle Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_description">Profile Desc</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length_mm">Length</Checkbox>
            </Col>

            <Col xs={24} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="weight_kg">Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="avg_weight_kg">Average</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_date">Packing Date</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const ItemWiseStockSummaryColumns = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedListThree}
          onChange={handleColumnVisibilityChangeItemWise}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                {' '}
                Sr. No.{' '}
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="workorder_no">Work Order No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Length</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="alloy">Alloy</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_weight">Total Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_pieces">Total Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_bundles">Total Bundles</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const handleExportBasedOnTab = () => {
    if (activeTab === '1') {
      handleExcel(); // Party Wise
      dispatch(
        createActivityLog({
          action: 'DOWNLOAD',
          module_name: 'Warehouse Bunlde OutWard',
          ip_address: ipAddress,
          discription: 'Warehouse bunlde outward excel download successfully!',
        }),
      );
    } else if (activeTab === '2') {
      handleExcelThree(); // Current Stock
      dispatch(
        createActivityLog({
          action: 'DOWNLOAD',
          module_name: 'Warehouse Bunlde OutWard',
          ip_address: ipAddress,
          discription: 'Warehouse bunlde outward excel download successfully!',
        }),
      );
    } else if (activeTab === '3') {
      handleExcelSummmary(); // Item Wise Summary
      dispatch(
        createActivityLog({
          action: 'DOWNLOAD',
          module_name: 'Warehouse Bunlde OutWard',
          ip_address: ipAddress,
          discription: 'Warehouse bunlde outward excel download successfully!',
        }),
      );
    }
  };

  const allCsvColumnsThree = [
    { header: 'Sr.No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Bundle No', dataKey: 'bundle_no', field: 'bundle_no' },
    { header: 'Profile', dataKey: 'profile', field: 'profile' },
    { header: 'Length(mm)', dataKey: 'length_mm', field: 'length_mm' },
    {
      header: 'Profile Description',
      dataKey: 'profile_description',
      field: 'profile_description',
    },
    { header: 'Pieces', dataKey: 'pieces', field: 'pieces' },
    { header: 'Weight', dataKey: 'weight_kg', field: 'weight_kg' },
    { header: 'Avg Wt(kg)', dataKey: 'avg_weight_kg', field: 'avg_weight_kg' },
    { header: 'Packing Date', dataKey: 'packing_date', field: 'packing_date' },
    { header: 'Customer Name', dataKey: 'customer_name', field: 'customer_name' },
  ];
  const csvHeadersThree = allCsvColumnsThree
    .filter(col => checkedList.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));
  const handleExcelThree = async () => {
    const count = totalRecordsCurrentStock;

    if (count > 0) {
      const response = await dispatch(
        fetchCurrentStockItemList({
          page: 1,
          pagesize: count,
          ...(searchCurrentStock && { search: searchCurrentStock }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ).unwrap();

      const bundles = response?.results?.data?.bundles || [];
      const csvListData = bundles.map((item, index) => {
        const row = {
          SrNo: index + 1, // Add serial number as the first column
        };
        allCsvColumnsThree
          .filter(col => checkedList.includes(col.field))
          .forEach(col => {
            if (col.field === 'SrNo') return; // Skip SrNo as it's already added

            switch (col.field) {
              case 'bundle_no':
                row.bundle_no = item?.bundle_no || 'N/A';
                break;
              case 'profile':
                row.profile = item?.profile || '0.0';
                break;
              case 'length_mm':
                row.length_mm = item?.length_mm || 'N/A';
                break;
              case 'profile_description':
                row.profile_description = item?.profile_description || 'N/A';
                break;
              case 'pieces':
                row.pieces = item?.pieces || 'N/A';
                break;
              case 'weight_kg':
                row.weight_kg = item?.weight_kg || 'N/A';
                break;
              case 'avg_weight_kg':
                row.avg_weight_kg = item?.avg_weight_kg?.toFixed(3) || 'N/A';
                break;
              case 'packing_date':
                row.packing_date = item?.packing_date
                  ? dayjs(item?.packing_date)
                    .format('DD-MM-YYYY h:mm A')
                    .toLowerCase()
                  : 'N/A';
                break;
              case 'customer_name':
                row.customer_name = item?.customer_name || 'N/A';
                break;
              default:
                row[col.dataKey] = 'N/A';
            }
          });

        return row;
      });

      setCsvData(csvListData);
      setTimeout(() => {
        csvLinkRef.current?.link.click();
      }, 500);
    }
  };

  const allCsvColumnsFour = [
    { header: 'Sr.No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Work Order No', dataKey: 'workorder_no', field: 'workorder_no' },
    { header: 'Profile', dataKey: 'profile', field: 'profile' },
    { header: 'Length (mm)', dataKey: 'length', field: 'length' },
    { header: 'Customer Name', dataKey: 'customer_name', field: 'customer_name' },
    { header: 'Alloy/ Color Code', dataKey: 'alloy', field: 'alloy' },
    { header: 'Total Weight', dataKey: 'total_weight', field: 'total_weight' },
    { header: 'Total Pieces', dataKey: 'total_pieces', field: 'total_pieces' },
    { header: 'Total Bundles', dataKey: 'total_bundles', field: 'total_bundles' },
  ];
  const csvHeadersFour = allCsvColumnsFour
    .filter(col => checkedListThree.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));
  const handleExcelSummmary = async () => {
    const countItemWiseSummary = totalRecordsSummaryWise;

    if (countItemWiseSummary > 0) {
      try {
        const response = await dispatch(
          fetchCurrentStockItemWiseSummary({
            page: 1,
            pagesize: countItemWiseSummary,
            ...(searchItemStockSummary && { search: searchItemStockSummary }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();

        const summaryData = response?.results?.data?.summary || [];
        const csvListDataFour = summaryData.map((item, index) => {
          const row = {
            SrNo: index + 1, // Add serial number as the first column
          };

          allCsvColumnsFour
            .filter(col => checkedListThree.includes(col.field))
            .forEach(col => {
              if (col.field === 'SrNo') return;
              switch (col.field) {
                case 'workorder_no':
                  row.workorder_no = item?.workorder_no || 'N/A';
                  break;
                case 'profile':
                  row.profile = item?.profile || 'N/A';
                  break;
                case 'length':
                  row.length = item?.length || 'N/A';
                  break;
                case 'customer_name':
                  row.customer_name = item?.customer_name || 'N/A';
                  break;
                case 'alloy':
                  row.alloy = item?.alloy || 'N/A';
                  break;
                case 'total_weight':
                  row.total_weight = item?.total_weight || 'N/A';
                  break;
                case 'total_pieces':
                  row.total_pieces = item?.total_pieces || 'N/A';
                  break;
                case 'total_bundles':
                  row.total_bundles =
                    item?.total_bundles !== null &&
                      item?.total_bundles !== undefined
                      ? item.total_bundles
                      : 'N/A';
                  break;
                default:
                  row[col.dataKey] = 'N/A';
              }
            });

          return row;
        });

        setCsvData(csvListDataFour); // set your CSV state here
        setTimeout(() => {
          csvLinkRef.current?.link.click();
        }, 500);
      } catch (error) {
        console.error('Error while fetching summary data for CSV:', error);
      }
    }
  };

  const handleShiftBundleExcessStock = bundleId => {
    const values = {
      bundle_id: [bundleId],
    };
    dispatch(shiftBundleExcessStock({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);

        message.success('Bundle Shifted To Excess Stock Successfully!');

        dispatch(
          fetchCurrentStockItemList({
            page: pageCurrentStock,
            pagesize: pagesizeCurrentStock,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        );
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };
  const handleDeleteBundle = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(deleteCurrentStockList(id))
      .unwrap()
      .then(() => {
        message.success('Excess stock bundle deleted permanently!');
        dispatch(
          fetchCurrentStockItemList({
            page: pageCurrentStock,
            pagesize: pagesizeCurrentStock,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        );
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  return (
    <div className="mainwrap">
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Warehouse Current Stock</h2>
              <div className="bredcrumbwrp">
                <Link onClick={() => navigate(-1)} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Warehouse Current Stock' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className="searchbox"
                  prefix={<SearchOutlined />}
                  value={
                    activeTab === '1'
                      ? inputValue
                      : activeTab === '2'
                        ? inputValueCurrentStock
                        : inputValueStockSummary
                  }
                  onChange={e => {
                    if (activeTab === '1') {
                      handleSearch(e);
                    } else if (activeTab === '2') {
                      handleSearchCurrentStock(e);
                    } else {
                      handleSearchStockSummary(e);
                    }
                  }}
                  style={{ width: '100%' }}
                />

                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={
                      (activeTab === '1' && !search && !orderBy) ||
                      (activeTab === '2' && !searchCurrentStock && !orderBy) ||
                      (activeTab === '3' && !searchItemStockSummary && !orderBy)
                    }
                    className="iconlink"
                    onClick={() => {
                      if (activeTab === '1') {
                        resetFilter();
                      } else if (activeTab === '2') {
                        resetFilterCurrentStock();
                      } else {
                        resetFilterStockSummary();
                      }
                    }}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
                {currentUser.permissions.permissions.warehouse.includes(
                  'download_warehouse_current_stock_excel_copy',
                ) && (
                    <Tooltip
                      title={
                        activeTab === '1'
                          ? 'Copy Warehouse Party Wise Stock Summary'
                          : activeTab === '2'
                            ? 'Copy Current Stock List'
                            : 'Copy Item Wise Stock Summary'
                      }
                    >
                      <Button
                        type="primary"
                        className="iconlink"
                        onClick={handleCopyBasedOnTab}
                      >
                        <CopyOutlined />
                      </Button>
                    </Tooltip>
                  )}
                <Tooltip
                  placement="top"
                  title={
                    activeTab === '1'
                      ? 'Export Excel'
                      : activeTab === '2'
                        ? 'Export Excel Current Stock'
                        : 'Export Excel Item Wise Summary'
                  }
                >
                  <Button
                    type="primary"
                    className="iconlink"
                    style={{ width: '10px' }}
                    onClick={handleExportBasedOnTab}
                  >
                    <FileExcelOutlined />
                  </Button>
                </Tooltip>
                <CSVLink
                  data={csvData}
                  filename={
                    activeTab === '1'
                      ? 'Party_Wise_Stock_Summary.csv'
                      : activeTab === '2'
                        ? 'Current_Stock_List.csv'
                        : 'Item_Wise_Stock_Summary.csv'
                  }
                  headers={
                    activeTab === '1'
                      ? csvHeaders
                      : activeTab === '2'
                        ? csvHeadersThree
                        : csvHeadersFour
                  }
                  className="hidden"
                  ref={csvLinkRef}
                >
                  Download
                </CSVLink>

                <div className="gridiconswrap">
                  <Tooltip
                    title={
                      activeTab === '1'
                        ? 'Warehouse Party Wise Stock Summary Columns'
                        : activeTab === '2'
                          ? 'Current Stock List Columns'
                          : 'Item Wise Stock Summary Columns'
                    }
                  >
                    <Dropdown
                      overlay={
                        activeTab === '1'
                          ? PartyWiseColumns
                          : activeTab === '2'
                            ? CurrentStockColumns
                            : ItemWiseStockSummaryColumns
                      }
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={e => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
        <Row gutter={16} className="mt-3">
          <Col xs={12} sm={8}>
            <div className="widwrp" style={{ backgroundColor: '#F7F6FF' }}>
              <div className="vidvaluerow mt-0">
                <div className="flex gap-2 items-center">
                  <label style={{ fontSize: '1.3rem' }}>Total Bundle :</label>
                  <span
                    style={{
                      fontSize: '1.5rem',
                      wordBreak: 'break-all',
                      fontWeight: 'bold',
                    }}
                  >
                    {visibleCounts.total_bundle || 0}
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={8}>
            <div className="widwrp" style={{ backgroundColor: '#e0f8e0' }}>
              <div className="vidvaluerow mt-0">
                <div className="flex gap-2 items-center">
                  <label style={{ fontSize: '1.3rem' }}>Verified :</label>
                  <span
                    style={{
                      fontSize: '1.5rem',
                      wordBreak: 'break-all',
                      fontWeight: 'bold',
                    }}
                  >
                    {visibleCounts.verified || 0}
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={8}>
            <div className="widwrp" style={{ backgroundColor: '#FFFBF6' }}>
              <div className="vidvaluerow mt-0">
                <div className="flex gap-2 items-center">
                  <label style={{ fontSize: '1.3rem' }}>Un-Verified :</label>
                  <span
                    style={{
                      fontSize: '1.5rem',
                      wordBreak: 'break-all',
                      fontWeight: 'bold',
                    }}
                  >
                    {visibleCounts.un_verified || 0}
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Tabs
        defaultActiveKey="1"
        className="tabletab px-4"
        onChange={handleTabChange}
      >
        <TabPane tab="Warehouse Party Wise Stock Summary" key="1">
          <div className="tablewrp">
            <Table
              rowKey="id"
              columns={filteredColumnsParty}
              dataSource={dataSource}
              pagination={false} // Disable built-in pagination
              loading={status === 'loading'}
              onChange={handleTableChangePartyWise}
              style={{ flex: 1, overflow: 'auto' }}
              scroll={{ x: '600px' }}
            />
          </div>

          <Pagination
            current={page}
            pageSize={pagesizePartyWise}
            total={totalRecordsPartyWise}
            pageSizeOptions={['20', '50', '100']}
            showSizeChanger
            onShowSizeChange={(current, size) => {
              setPagesize(size);
              setPage(1); // reset to first page on size change
            }}
            onChange={newPage => {
              setPage(newPage);
            }}
            showTotal={total => `Total ${total} items`}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </TabPane>
        <TabPane tab="Warehouse Current Stock List" key="2">
          <div className="tablewrp">
            <Table
              rowKey="id"
              columns={filteredColumns}
              dataSource={dataSourceThree}
              pagination={false} // Disable built-in pagination
              loading={status === 'loading'}
              onChange={handleTableChangeCurrentStock}
              style={{ flex: 1, overflow: 'auto' }}
              scroll={{ x: '600px' }}
            />
          </div>

          <Pagination
            current={pageCurrentStock}
            pageSize={pagesizeCurrentStock}
            total={totalRecordsCurrentStock}
            pageSizeOptions={['20', '50', '100']}
            showSizeChanger
            onShowSizeChange={(current, size) => {
              setPagesizeCurrentStock(size);
              setPageCurrentStock(1);
            }}
            onChange={newPage => {
              setPageCurrentStock(newPage);
            }}
            showTotal={total => `Total ${total} items`}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </TabPane>
        <TabPane tab="Warehouse Item Wise Stock Summary" key="3">
          <div className="tablewrp">
            <Table
              rowKey="id"
              columns={filteredColumnsItemWise}
              dataSource={dataSourceFour}
              pagination={false} // Disable built-in pagination
              loading={status === 'loading'}
              onChange={handleTableChangeItemWiseSummary}
              scroll={{ x: '600px' }}
            />
          </div>

          <Pagination
            current={pageItemWiseSummary}
            pageSize={pagesizeItemWiseSummary}
            total={totalRecordsSummaryWise}
            pageSizeOptions={['20', '50', '100']}
            showSizeChanger
            onShowSizeChange={(current, size) => {
              setPagesizeItemWiseSummary(size);
              setPageItemWiseSummary(1);
            }}
            onChange={newPage => {
              setPageItemWiseSummary(newPage);
            }}
            showTotal={total => `Total ${total} items`}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default WareHouseCurrentStock;